import type { CodeKernelLanguage } from "../../../shared/worksheets/code-kernels";

import type { SectionType } from "components/server-types";

export type GeneralFormValues = {
  allowLateSubmissions: boolean;
  anonymous_grading_enabled: boolean;
  code_blocks_default_language: CodeKernelLanguage;
  code_blocks_enabled: boolean;
  section_language: SectionType["section_language"];
  daysLate: number;
  hide_static_blocks_on_student_response_page: boolean;
  projector_zoom: number;
  should_lock_pages_at_due_date: boolean;
  student_ai_assistant_enabled: boolean;
  ai_assessment_enabled: boolean;
};

export type SectionInfoFormValues = {
  title: string;
  description: string;
  external_section_id: string;
  course_id: string;
  term_id: string;
};

export type GradeFormValues = {
  section_score_enabled: boolean;
  section_score_prepwork_percentage: number;
  section_score_activities_percentage: number;
  section_score_assignments_percentage: number;
};

export type VirtualClassFormValues = {
  auto_recordings_enabled: boolean;
  av_enabled: boolean;
  av_service: string;
  mute_students_on_main_room_entry: boolean;
};

export const TAB_INDEX = {
  general: 0,
  sectionInfo: 1,
  grade: 2,
  virtualClass: 3,
} as const;
